export default {
  created() {
  },
  methods: {
  },
  computed: {
    // types() {
    //   return [
    //     { text: this.$t('Releases.IMPROVE'), value: 'IMPROVE' },
    //     { text: this.$t('Releases.NEW_FEATURE'), value: 'NEW_FEATURE' },
    //     { text: this.$t('Releases.BUG_FIX'), value: 'BUG_FIX' },
    //   ]
    // }

    featureDetail() {
      let details = this.$store.getters.getFeatureDetail,
        obj = this.$_.keyBy(details, 'type')
      obj.all = { amount: details.reduce((total, el) => total += el.amount ,0) }
      return obj
    },
    types() {
      let types = Object.values( this.featureDetail )
        .map(el => ({...el, text: this.$t('Releases.' + (el.type || 'AllModifications')),}))
      return types.reverse()
    }
  }
}
